<template>
    <div class="TagSelectOptions">
      <el-option
        v-for="(o, index) in item.options||ajaxOptions"
        :key="o[item.key]"
        :label="o[item.label]"
        :value="o[item.key]"
        :disabled="o[item.disabled]">
        <div v-if="item.tagUsed === true">
          <el-tag v-if="item.tagType === 'default'"  effect="light" size="mini" type="" class="mh-option-tag mh-option-tag-default">{{ o[item.label] }}</el-tag>
          <el-tag v-else-if="item.tagType === 'randomLight'" effect="light" type="info" size="mini" class="mh-option-tag" :style="mhOptionTagRandom(item.tagType, index)">{{ o[item.label] }}</el-tag>
          <el-tag v-else-if="item.tagType === 'randomDark'"  effect="dark" type="info" size="mini" class="mh-option-tag" :style="mhOptionTagRandom(item.tagType, index)">{{ o[item.label] }}</el-tag>
          <el-tag v-else-if="item.tagType === 'randomPlain'" effect="plain" type="info" size="mini" class="mh-option-tag" :style="mhOptionTagRandom(item.tagType, index)">{{ o[item.label] }}</el-tag>
          <el-tag v-else-if="item.tagType === 'custom'" :effect="o.mapkvdEffect" type="info" size="mini" class="mh-option-tag" :style="mhOptionTagCustom(o.mapkvdColor)">{{ o[item.label] }}</el-tag>
        </div>
        <div v-else>
          <span>{{ o[item.label] }}</span>
        </div>
      </el-option>
    </div>
</template>
<script>
import colorUtils from '../../assets/js/colors.js'
export default {
  name: 'TagSelectOptions',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      ajaxOptions: [],
      tagColors: [],
      tad1: [
        '#f67e7a', '#f797cd', '#e040fb',
        '#7c4dff', '#7c84ee', '#5789ff',
        '#29ccb7', '#3dbc2f', '#9fda59',
        '#95b200', '#ffca28', '#ffa726',
        '#a1887f', '#78909c', '#646a73'
      ],
      tagLightColors: [
        '#f75550', '#ef57ad', '#ab47bc',
        '#7c4dff', '#3250eb', '#409eff',
        '#00bfaa', '#1ba70c', '#87d136',
        '#819a04', '#ffc107', '#ff9800',
        '#795548', '#607d8b', '#51565d'
      ],
      tagDarkColors: [
        '#f75550', '#ef57ad', '#ab47bc',
        '#7c4dff', '#3250eb', '#409eff',
        '#00bfaa', '#1ba70c', '#87d136',
        '#819a04', '#ffc107', '#ff9800',
        '#795548', '#607d8b', '#51565d'
      ],
      tagPlainColors: [
        '#FF0000', '#FF1493', '#aa00ff',
        '#7c4dff', '#3250eb', '#409eff',
        '#00bfaa', '#1ba70c', '#87d136',
        '#819a04', '#ffab00', '#ff6d00',
        '#6d4c41', '#455a64', '#212121'
      ]
    }
  },
  methods: {
    loadAjaxOptions: async function () {
      const that = this
      const { url, para } = that.item
      if (url) {
        const { data: res } = await that.$http.post(url, para)
        that.ajaxOptions = res.data
      }
    },
    getRandomColor (tagType, index) {
      const that = this
      let colors
      if (tagType === 'randomLight') {
        colors = that.tagLightColors
      } if (tagType === 'randomDark') {
        colors = that.tagDarkColors
      } if (tagType === 'randomPlain') {
        colors = that.tagPlainColors
      }
      const length = colors.length
      const color = colors[index % length]
      return color
    },

    mhOptionTagRandom (tagType, index) {
      const that = this
      let thyColor
      let backgroundColor
      let borderColor
      let fontColor
      if (tagType === 'randomLight') {
        thyColor = that.tagLightColors[index % that.tagLightColors.length]
        backgroundColor = colorUtils.hexToRgba(thyColor, 0.2)
        fontColor = '#1f2329'
        borderColor = backgroundColor
      } else if (tagType === 'randomDark') {
        thyColor = that.tagDarkColors[index % that.tagDarkColors.length]
        backgroundColor = colorUtils.hexToRgba(thyColor, 1)
        fontColor = '#FFFFFF'
        borderColor = backgroundColor
      } else if (tagType === 'randomPlain') {
        thyColor = that.tagPlainColors[index % that.tagPlainColors.length]
        backgroundColor = '#FFFFFF'
        fontColor = colorUtils.hexToRgba(thyColor, 1)
        borderColor = fontColor
      }
      return {
        backgroundColor: backgroundColor,
        color: fontColor,
        borderColor: borderColor,
        borderStyle: 'solid',
        borderWidth: '1px'
      }
    },
    mhOptionTagCustom (mapkvdColor) {
      let thyEffect
      let thyColor
      let backgroundColor
      let borderColor
      let fontColor
      if (mapkvdColor !== '' && mapkvdColor.includes(';')) {
        const arr = mapkvdColor.split(';')
        thyEffect = arr[0]
        thyColor = arr[1]
      } else {
        thyEffect = ''
        thyColor = ''
      }
      if (thyEffect === 'light') {
        backgroundColor = colorUtils.hexToRgba(thyColor, 0.2)
        fontColor = '#1f2329'
        borderColor = backgroundColor
      } else if (thyEffect === 'dark') {
        backgroundColor = colorUtils.hexToRgba(thyColor, 1)
        fontColor = '#FFFFFF'
        borderColor = backgroundColor
      } else if (thyEffect === 'plain') {
        backgroundColor = '#FFFFFF'
        fontColor = colorUtils.hexToRgba(thyColor, 1)
        borderColor = fontColor
      } else {
        backgroundColor = '#ecf5ff'
        fontColor = '#409eff'
        borderColor = fontColor
      }
      return {
        backgroundColor: backgroundColor,
        color: fontColor,
        borderColor: borderColor,
        borderStyle: 'solid',
        borderWidth: '1px'
      }
    }
  },
  created () {
    this.loadAjaxOptions()
    // this.getRandomColor()
  }
}
</script>

<style lang="less" scoped>
  .TagSelectOptions {
    .mh-option-tag {
      padding: 0 10px;
      margin: 2px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
    }
    .mh-option-tag-default {
      color: #409eff;
      background-color: #ecf5ff;
      border: 1px solid #d9ecff;
    }
  }
</style>
